<template>
  <div>
    <DxDataGrid
      :data-source="items"
      :show-borders="true"
      :row-alternation-enabled="true"
      :allow-column-resizing="true"
      :show-column-headers="showHeader"
      :ref="dataGridRefKey"
      key-expr="id"
      @content-ready="onContentReady"
      @editor-preparing="onValueChanged"
      @toolbar-preparing="onToolbarPreparing"
    >
      <!-- Paging and Pager -->
      <DxPaging :page-size="pageSize" v-if="showPagination" />
      <DxPager
        :show-page-size-selector="true"
        :allowed-page-sizes="[10, 20, 50]"
        :show-info="true"
      />

      <DxColumnFixing :enabled="true" />

      <!-- Set Columns -->
      <DxColumn
        v-for="(head, index) in headers"
        :key="index"
        :width="head.width"
        :data-type="head.type"
        :caption="head.text"
        :data-field="head.value"
        :cell-template="head.cellTemplate"
        :allow-sorting="head.text !== 'Action' && options.allowSorting"
        :allow-filtering="head.text !== 'Action'"
        :visible="head.visible"
        :format="head.type.includes('date') ? 'shortDateShortTime' : ''"
        :filter-operations="['contains']"
        :editor-options="{}"
        :calculate-sort-value="calculateSortValue"
      />

      <!-- Activate Selection -->
      <DxSelection
        :select-all-mode="'allPages'"
        :show-check-boxes-mode="'onClick'"
        v-if="options.allowMultipleSelect"
        mode="multiple"
      />

      <!-- Activate Filter -->
      <DxFilterRow :visible="true" apply-filter="onClick" />

      <!-- Templates -->
      <template #whiteSpace="{ data }">
        <div class="whitespace-normal">{{ data.value }}</div>
      </template>
    </DxDataGrid>

    <!-- Dialog delete -->
    <el-dialog :visible.sync="dialogVisible" width="30%"></el-dialog>
  </div>
</template>
<script>
/* eslint-disable */
import {
  DxForm,
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxPager,
  DxEditing,
  DxSelection,
  DxFilterRow,
  DxExport,
  DxColumnFixing
} from 'devextreme-vue/data-grid'
import {
  DxSimpleItem,
  DxLabel,
  DxRequiredRule,
  DxPatternRule
} from 'devextreme-vue/form'
import { DxTextBox } from 'devextreme-vue/text-box'
import moment from 'moment'

const dataGridRefKey = 'my-data-grid'
export default {
  props: {
    headers: {
      type: Array
    },
    items: {
      type: Array
    },
    options: {
      type: Object,
      default: function () {
        return {
          allowAdding: false,
          allowEditing: false,
          allowDeleting: false,
          allowExporting: false,
          allowSorting: true,
          allowMultipleSelect: true
        }
      }
    },
    customizationPage: {
      type: String
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    showPagination: {
      type: Boolean,
      default: true
    },
    pageSize: {
      type: Number,
      default: 10
    },
    filter: {
      type: Object
    },
    search: {
      type: Array
    }
  },
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxPager,
    DxEditing,
    DxForm,
    DxSelection,
    DxFilterRow,
    DxExport,
    DxSimpleItem,
    DxLabel,
    DxRequiredRule,
    DxPatternRule,
    DxTextBox,
    DxColumnFixing
  },
  data: () => {
    return {
      alphaPattern: /^[^0-9]+$/, // eslint-disable-line
      numericPattern: /^(0|[1-9][0-9]*)$/, // eslint-disable-line
      emailPattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, // eslint-disable-line
      dialogVisible: false,
      dataGridRefKey
    }
  },
  methods: {
    onContentReady(e) {
      let data = e.component
      for (let i = 0; i < data.columnCount(); i++) {
        let column = data.columnOption(i)
        if (
          column.bufferedFilterValue &&
          column.bufferedFilterValue.length > 0
        ) {
          let index = this.$parent.filter.search.findIndex(
            (x) =>
              x.key == column.dataField && x.value != column.bufferedFilterValue
          )
          if (index >= 0)
            this.$parent.filter.search[index].value = column.bufferedFilterValue
        }
        if (column.sortOrder) {
          this.$parent.filter.orderby = column.dataField
          this.$parent.filter.order = column.sortOrder
        }
      }
    },
    onValueChanged(e) {
      if (e.parentType === 'filterRow') {
        e.editorOptions.showClearButton = true
        const defaultValueChangeHandler = e.editorOptions.onValueChanged
        let data = { dataField: null, value: '' }
        let filter = this.filter
        e.editorOptions.onValueChanged = function (args) {
          if (typeof args.value == 'object' && e.dataType.includes('date')) {
            let index = filter.search.findIndex((x) => x.key == e.dataField)
            if (args.value) {
              let date = moment(args.value).format('YYYY-MM-DD')
              index >= 0
                ? (filter.search[index].value = date)
                : filter.search.push({ key: e.dataField, value: date })
              defaultValueChangeHandler(args)
            } else {
              if (index >= 0) filter.search.splice(index, 1)
              defaultValueChangeHandler(args)
            }
          } else {
            if (args.value && args.value.length > 0) {
              data.dataField = e.dataField
              data.value = args.value
              defaultValueChangeHandler(args)
            }
            if (args.value == '' && args.value.length == 0) {
              let index = filter.search.findIndex((x) => x.key == e.dataField)
              if (index >= 0) filter.search[index].value = ''
              defaultValueChangeHandler(args)
            }
          }
        }

        const defaultKeyDownHandler = e.editorOptions.onKeyDown
        e.editorOptions.onKeyDown = function (args) {
          if (args.event && args.event.keyCode == 13) {
            filter.search.forEach((item, index) => {
              if (item.key == data.dataField) {
                filter.search[index].value = data.value
              }
            })
          }
        }
      }
    },
    onToolbarPreparing(e) {
      let toolbarItems = e.toolbarOptions.items
      toolbarItems.forEach((item) => {
        if (item.name === 'applyFilterButton') {
          // Change the item options here
          item.visible = false
        }
      })
    },
    calculateSortValue(e) {},
    clearAll() {
      this.dataGrid.clearSorting()
      this.dataGrid.clearFilter()
      this.dataGrid.refresh()
    },
    moment: function () {
      return moment()
    }
  },
  computed: {
    dataGrid() {
      return this.$refs[dataGridRefKey].instance
    }
  }
}
</script>

<style lang="scss" scoped>
#data-grid-demo {
  min-height: 700px;
}

.simple-link {
  color: #478ed1;
  text-decoration: underline;
  cursor: pointer;
  margin: 0px 3px;
}
.simple-link.labeled-icon {
  text-decoration: none;
}
.simple-link.icon {
  font-size: 28px;
  text-decoration: none;
}
.simple-link.disabled {
  color: #ccc;
  cursor: unset;
}

// Custom Dropdown

.dropbtn {
  background-color: white;
  color: #333333;
  border: 1px solid #dddddd;
  border-radius: 3px;
  padding: 5px 10px;
  font-size: 12px;
  cursor: pointer;
}

.dropbtn:hover,
.dropbtn:focus {
  background-color: #f1f1f1;
}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content {
  display: none;
  position: absolute;
  margin-top: 3px;
  border: 1px solid #dddddd;
  border-radius: 3px;
  min-width: 100px;
  overflow: auto;
  z-index: 1;
}

.dropdown-content a {
  color: black;
  padding: 5px 10px;
  text-decoration: none;
  display: block;
}

.dropdown a:hover {
  background-color: #ddd;
}

.show {
  display: block;
}
</style>
